import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface ConfigStore {
  prefix: string;
  setPrefix: (prefix: string) => void;
  clearConfig: () => void;
}

export const useConfigStore = create<ConfigStore>()(
  persist(
    (set) => ({
      prefix: "",

      setPrefix: (prefix) => {
        set({ prefix });
      },

      clearConfig: () => {
        set({ prefix: "" });
      },
    }),
    {
      name: "config-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
